<template>
  <div>
    <b-row style="margin-bottom:5px">
      <b-col md="12" class="text-center mt-1"
        ><b> Set {{ item.set_numero }}</b></b-col
      >
      <b-col md="6">
        <div style="display:flex; justify-content:center">
          <b-form-input
            v-model="item.marcador_local"
            id="item-lc"
            type="number"
            placeholder="Puntaje"
            size="sm"
            style="width:100px"
            :style="`color:${item.color}`"
            @input="changePuntaje('local')"
            :disabled="estadoPartido == 'PJ' ? false : true"
          />
        </div>
      </b-col>
      <b-col md="6">
        <div style="display:flex; justify-content:center">
          <b-form-input
            v-model="item.marcador_visitante"
            id="item-vs"
            type="number"
            placeholder="Puntaje"
            size="sm"
            style="width:100px"
            :style="`color:${item.color}`"
            @input="changePuntaje('visita')"
            :disabled="estadoPartido == 'PJ' ? false : true"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BFormInput,
  //   BFormTextarea,
  //   BFormGroup,
  //   BInputGroupPrepend,
  //   BInputGroup,
  //   BFormCheckbox,
  //   BAlert,
  VBTooltip,
  //   BSpinner,
  //   VBPopover,
  //   BAvatar,
  //   BPopover,
  //   BForm,
  //   BInputGroup,
  //   BInputGroupPrepend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    item: Object,
    estadoPartido: String,
  },
  setup(props, { emit }) {
    function changePuntaje(tipoAplicado) {
      // console.log(tipoAplicado)
      emit('sumaSets', tipoAplicado)
    }

    return {
      changePuntaje,
    }
  },
}
</script>
